var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button } from 'semantic-ui-react';
var CustomButton = function (props) {
    var iconBefore = props.iconBefore, icon = props.icon, children = props.children, labeled = props.labeled, _a = props.iconStyles, iconStyles = _a === void 0 ? {} : _a, buttonProps = __rest(props, ["iconBefore", "icon", "children", "labeled", "iconStyles"]);
    return (React.createElement(Button, __assign({ icon: !buttonProps.basic && !!icon, labelPosition: labeled && icon ? (iconBefore ? 'left' : 'right') : null }, buttonProps),
        iconBefore && icon && (React.createElement("i", { className: "icon", style: __assign({}, iconStyles) }, icon)),
        children,
        !iconBefore && icon && (React.createElement("i", { className: "icon", style: __assign({}, iconStyles) }, icon))));
};
export default CustomButton;
